export interface TourManagerState {
  tourStart: boolean;
}

export const initialTourManagerState: TourManagerState = {
  tourStart: false,
};